import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ContainerScrollModule } from '@app/components/container-scroll/container-scroll.module';
import { DialogModule } from '@app/components/dialog/dialog.module';
import { IconsModule } from '@app/components/icons/icons.module';
import { SharedModule } from '@app/shared/shared.module';

import { DialogScoreComponent } from './dialog-score/dialog-score.component';
import { ProfileEditComponent } from './profile-edit/profile-edit.component';
import { ProfileRoutingModule } from './profile-routing.module';
import { ProfileComponent } from './profile.component';
@NgModule({
  declarations: [
    ProfileComponent,
    ProfileEditComponent,
    DialogScoreComponent,],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    ReactiveFormsModule,
    ProfileRoutingModule,
    DialogModule,
    ContainerScrollModule
  ],
  entryComponents: [
    DialogScoreComponent
  ]
})
export class ProfileModule { }
